// components/Footer.tsx
import Image from 'next/image';
import img from "@/public/assets/images/img.png"
import Link from 'next/link';
import Footerlogo from '@/public/assets/images/Foorterlogo.png'
interface Category {
  name: string;
  seo_url: string;
}

const Footer = ({ categoryListData }: { categoryListData?: Category[] }) => {
  // Safe fallback: use empty array if no data
  const categories = categoryListData || [];

  return (
    <footer className="bg-[#0b1a33] text-white">
      {/* Top */}
      <div className="max-w-7xl mx-auto px-4 py-[48px]">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[100px]">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Image
                src={Footerlogo}
                alt="Fasica Power Solutions"
                width={206}
                height={36}
              />
            </div>

            <p className="text-sm text-white/70 leading-relaxed max-w-sm">
              Delivering safe, reliable, and cost-effective electrical
              solutions across India.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-jakarta font-[600] mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>Electrical Systems (LV, HV, UHV)</li>
              <li>CCTV Solutions</li>
              <li>Solar Power</li>
              <li>Home Automation</li>
              <li>
                <Link href="/about" className="hover:underline">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-jakarta font-[600] mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>Phone: +91 98765 43210</li>
              <li>Email: info@fpsinj.com</li>
              <li>Chennai, Tamil Nadu, India</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className=" flex justify-center border-t border-white/10 py-4 text-center text-xs text-white/50  pb-[48px]">
        © {new Date().getFullYear()} Fasica Power Solutions | Powered By <p className="">
          <Link
            href="https://vilvabusiness.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#195AFF] transition-colors"
          >
            &nbsp; Vilva⚡Your Technology Partner
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;